import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_5 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_6 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_7 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_8 = { class: "text-right q-mb-sm" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { style: { "white-space": "nowrap", "overflow": "hidden", "text-overflow": "ellipsis", "width": "100%" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_select = _resolveComponent("q-select");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_expansion_item = _resolveComponent("q-expansion-item");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_td = _resolveComponent("q-td");
    const _component_q_tr = _resolveComponent("q-tr");
    const _component_my_page_table = _resolveComponent("my-page-table");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.top },
                    { itemId: _ctx.infoList }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_card, { class: "q-mb-lg" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_expansion_item, {
                                            class: "search-expansion",
                                            icon: "search",
                                            label: "検索条件",
                                            modelValue: _ctx.expansionState,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.expansionState) = $event)),
                                            dense: ""
                                        }, {
                                            header: _withCtx(() => [
                                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_icon, { name: "search" })
                                                    ]),
                                                    _: 1
                                                }),
                                                (_ctx.expansionState)
                                                    ? (_openBlock(), _createBlock(_component_q_item_section, {
                                                        key: 0,
                                                        class: "text-large text-weight-bold q-py-sm"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                                _createTextVNode("検索条件 ", -1)
                                                            ]))]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true),
                                                (!_ctx.expansionState)
                                                    ? (_openBlock(), _createBlock(_component_q_item_section, {
                                                        key: 1,
                                                        class: "text-large text-weight-bold q-py-sm display-condition"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.storedCondition.summary), 1)
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_separator),
                                                _createVNode(_component_q_card_section, null, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_3, [
                                                            _createElementVNode("div", _hoisted_4, [
                                                                _cache[8] || (_cache[8] = _createElementVNode("div", null, "掲載状況", -1)),
                                                                _createVNode(_component_q_select, {
                                                                    modelValue: _ctx.condition.status,
                                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.condition.status) = $event)),
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    options: _ctx.publishStatusList,
                                                                    dense: "",
                                                                    outlined: ""
                                                                }, null, 8, ["modelValue", "options"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_5, [
                                                                _cache[9] || (_cache[9] = _createElementVNode("div", null, "掲載対象", -1)),
                                                                _createVNode(_component_q_select, {
                                                                    modelValue: _ctx.condition.target,
                                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.condition.target) = $event)),
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    options: _ctx.publishKbnList,
                                                                    dense: "",
                                                                    outlined: ""
                                                                }, null, 8, ["modelValue", "options"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_6, [
                                                                _cache[10] || (_cache[10] = _createElementVNode("div", null, "掲載対象名", -1)),
                                                                _createVNode(_component_q_input, {
                                                                    dense: "",
                                                                    outlined: "",
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    modelValue: _ctx.condition.targetName,
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.condition.targetName) = $event)),
                                                                    "no-error-icon": "",
                                                                    error: _ctx.conditionValid.targetName.error,
                                                                    "error-message": _ctx.conditionValid.targetName.message
                                                                }, null, 8, ["modelValue", "error", "error-message"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_7, [
                                                                _cache[11] || (_cache[11] = _createElementVNode("div", null, "タイトル", -1)),
                                                                _createVNode(_component_q_input, {
                                                                    dense: "",
                                                                    outlined: "",
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    modelValue: _ctx.condition.subject,
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.condition.subject) = $event)),
                                                                    "no-error-icon": "",
                                                                    error: _ctx.conditionValid.subject.error,
                                                                    "error-message": _ctx.conditionValid.subject.message
                                                                }, null, 8, ["modelValue", "error", "error-message"])
                                                            ])
                                                        ])
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_q_separator),
                                                _createVNode(_component_q_card_actions, { class: "row justify-center q-py-md bg-grey-1" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_btn, {
                                                            icon: "search",
                                                            class: "col-8 col-sm-6 col-md-3 col-lg-3",
                                                            label: "検索",
                                                            color: "green-7",
                                                            onClick: _ctx.onSearch
                                                        }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_q_btn, {
                                        label: "新規登録",
                                        icon: "add_circle_outline",
                                        color: "green-7",
                                        onClick: _ctx.onCreateNew
                                    }, null, 8, ["onClick"])
                                ]),
                                _createVNode(_component_my_page_table, {
                                    rows: _ctx.results,
                                    columns: _ctx.columns,
                                    executeDate: _ctx.foundDate,
                                    "row-key": "informationNo",
                                    pagination: _ctx.pagination,
                                    "onUpdate:pagination": _cache[5] || (_cache[5] = ($event) => ((_ctx.pagination) = $event)),
                                    request: _ctx.onRequest,
                                    class: "no-hover",
                                    enableSelection: false
                                }, {
                                    body: _withCtx((props) => [
                                        _createVNode(_component_q_tr, {
                                            props: props,
                                            style: _normalizeStyle(props.row.isPastEndAt ? 'background-color: #E6E6E6' : '')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_td, { class: "text-center" }, {
                                                    default: _withCtx(() => [
                                                        (props.row.weight)
                                                            ? (_openBlock(), _createBlock(_component_q_icon, {
                                                                key: 0,
                                                                name: "info",
                                                                size: "md",
                                                                color: "red"
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-center" }, {
                                                    default: _withCtx(() => [
                                                        (props.row.isResponseRequired)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                                (props.row.isAnswered)
                                                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                                                        key: 0,
                                                                        name: "mark_email_read",
                                                                        size: "md",
                                                                        color: "grey"
                                                                    }))
                                                                    : _createCommentVNode("", true),
                                                                (!props.row.isAnswered)
                                                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                                                        key: 1,
                                                                        name: "mark_email_unread",
                                                                        size: "md",
                                                                        color: "orange"
                                                                    }))
                                                                    : _createCommentVNode("", true)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-center" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(props.row.startAt), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-center" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(props.row.endAt), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-left" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.getTargetName(props.row.target)), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-left" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(props.row.targetName), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, {
                                                    class: "text-left",
                                                    style: { "width": "450px", "max-width": "450px" }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_10, _toDisplayString(props.row.subject), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, null, {
                                                    default: _withCtx(() => [
                                                        (props.row.isResponseRequired)
                                                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                                                key: 0,
                                                                "no-wrap": "",
                                                                label: "回答確認",
                                                                icon: "forward_to_inbox",
                                                                color: "green-7",
                                                                onClick: ($event) => (_ctx.onResponseCheck(props.row.informationNo))
                                                            }, null, 8, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, null, {
                                                    default: _withCtx(() => [
                                                        (!_ctx.isCanViewOnly(props.row.target))
                                                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                                                key: 0,
                                                                label: "コピー",
                                                                icon: "content_copy",
                                                                color: "green-7",
                                                                "no-wrap": "",
                                                                onClick: ($event) => (_ctx.onCopy(props.row.informationNo))
                                                            }, null, 8, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_btn, {
                                                            "no-wrap": "",
                                                            label: _ctx.isCanViewOnly(props.row.target) ? '閲覧' : '編集',
                                                            icon: _ctx.isCanViewOnly(props.row.target) ? 'lock' : 'edit',
                                                            color: "green-7",
                                                            onClick: ($event) => (_ctx.onClick(props.row.informationNo))
                                                        }, null, 8, ["label", "icon", "onClick"])
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1032, ["props", "style"])
                                    ]),
                                    _: 1
                                }, 8, ["rows", "columns", "executeDate", "pagination", "request"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "トップに戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$router.push({ name: 'top' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
